module.exports = __webpack_public_path__ + "img/major.94d4a2b3.png";